import React from 'react';
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';

const ErrorPage: React.FC = () => {
  const error = useRouteError();
  console.error("Frontend Error Caught:", error);

  let errorMessage: string;
  let errorDetails: any = null; // To hold more technical details

  if (isRouteErrorResponse(error)) {
    errorMessage = `${error.status} - ${error.statusText}`;
    // Attempt to extract more details from the response body if available
    // Note: Accessing error.data might not always be appropriate or safe depending on the backend response structure and data sensitivity.
    // For development, displaying it can be useful.
    errorDetails = error.data; 
  } else if (error instanceof Error) {
    errorMessage = error.message;
    // For standard Error objects, the stack trace can be useful
    errorDetails = error.stack;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else {
    errorMessage = 'An unexpected error occurred.';
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-red-100 text-red-800 p-4">
      <h1 className="text-3xl font-bold mb-4">Oops!</h1>
      <p className="text-xl mb-4">Sorry, an unexpected error has occurred.</p>
      <p className="text-lg italic mb-4">{errorMessage}</p>

      {/* Display technical details if available */}
      {errorDetails && (
        <div className="w-full max-w-md p-4 bg-red-200 rounded break-words text-sm text-red-900">
          <h2 className="font-semibold mb-2">Technical Details:</h2>
          {typeof errorDetails === 'object' ? (
            <pre className="whitespace-pre-wrap">{JSON.stringify(errorDetails, null, 2)}</pre>
          ) : (
            <p>{String(errorDetails)}</p>
          )}
        </div>
      )}
      
      {/* Optionally, add a link to go back or report the issue */}
      {/* <Link to="/" className="mt-4 text-red-700 hover:underline">Go Home</Link> */}
    </div>
  );
};

export default ErrorPage; 